import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "none",
  "shape-rendering": "geometricPrecision"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10",
      cy: "10",
      r: "8.75",
      fill: "var(--remove-circle-bg, currentColor)",
      stroke: "var(--remove-circle-ring, rgba(255, 255, 255, 0.9))",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.5 6.5L13.5 13.5M13.5 6.5L6.5 13.5",
      stroke: "var(--remove-circle-fg, #fff)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "vector-effect": "non-scaling-stroke"
    }, null, -1)
  ]))]))
}
export default { render: render }